const BASE_URL = `${process.env.REACT_APP_API_PERMITS_BASE_URL}/Permits`;

const json = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response.status === 204 ? null : response.json();
  }
  throw response;
};

export const getObjectIdsForArea = async (token, parkingAreaExtId) => {
  const response = await fetch(`${BASE_URL}/parking-spots/by-area/${parkingAreaExtId.toLowerCase()}/objectids`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  });
  return json(response);
};

export const bulkUpdateObjectIds = async (token, parkingAreaExtId, items) => {
  const response = await fetch(`${BASE_URL}/parking-spots/objectids/bulk-update`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ parkingAreaExtId, items }),
  });
  return json(response);
};

// Anton-review-backfill 2026-04-30: per-rad-preview mot systemdata UTAN att skriva.
// Visas i modal innan användaren bekräftar bulk-update.
export const previewObjectIds = async (token, parkingAreaExtId, items) => {
  const response = await fetch(`${BASE_URL}/parking-spots/objectids/preview`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ parkingAreaExtId, items }),
  });
  return json(response);
};
